/**
 * Display order for platform ids in the filter chip and details dialog.
 * Edit this list to change the order; ids not listed are appended at the end.
 */
export const PLATFORM_DISPLAY_ORDER = Object.freeze([
  // Québec
  'seao_v2',
  'hydroquebec',
  // National / Ontario
  'canada_buys',
  'merx',
  'bidsandtenders',
  'bonfire',
  'jaggaer',
  'infrastructure_ontario',
  'biddingo',
  // Other provinces
  'alberta',
  'british_columbia',
  'new_brunswick',
  'newfoundland_and_labrador',
  'nova_scotia',
  'prince_edward_island',
  'saskatchewan',
  // Territories
  'yukon',
  'northwest_territories',
  'nunavut',
  // Other platforms
  'pige_quebec',
  'bsdq',
  // Old platforms
  'buyandsell',
  'seao',
  'constructo',
]);

export function sortPlatformsByDisplayOrder(platforms, order = PLATFORM_DISPLAY_ORDER) {
  if (!Array.isArray(platforms) || !platforms.length) return [];
  const rank = new Map((order || []).map((id, index) => [id, index]));
  const fallback = (order && order.length) || 0;
  return [...platforms].sort((a, b) => {
    const aId = a && a.id;
    const bId = b && b.id;
    const aRank = rank.has(aId) ? rank.get(aId) : fallback;
    const bRank = rank.has(bId) ? rank.get(bId) : fallback;
    if (aRank !== bRank) return aRank - bRank;
    return String(aId || '').localeCompare(String(bId || ''));
  });
}
